module.exports = (string) =>
  string
    .toLowerCase()
    .trim()
    .replace(new RegExp(/\s+/, 'g'), '-')
    .replace(new RegExp(/[^\w-]/, 'g'), '')
